/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PagingInfo } from './PagingInfo';
import {
    PagingInfoFromJSON,
    PagingInfoFromJSONTyped,
    PagingInfoToJSON,
} from './PagingInfo';
import type { SearchDTO } from './SearchDTO';
import {
    SearchDTOFromJSON,
    SearchDTOFromJSONTyped,
    SearchDTOToJSON,
} from './SearchDTO';

/**
 * 
 * @export
 * @interface UserSearchResponse
 */
export interface UserSearchResponse {
    /**
     * 
     * @type {Array<SearchDTO>}
     * @memberof UserSearchResponse
     */
    results: Array<SearchDTO>;
    /**
     * 
     * @type {PagingInfo}
     * @memberof UserSearchResponse
     */
    pagingInfo: PagingInfo;
}

/**
 * Check if a given object implements the UserSearchResponse interface.
 */
export function instanceOfUserSearchResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;
    isInstance = isInstance && "pagingInfo" in value;

    return isInstance;
}

export function UserSearchResponseFromJSON(json: any): UserSearchResponse {
    return UserSearchResponseFromJSONTyped(json, false);
}

export function UserSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(SearchDTOFromJSON)),
        'pagingInfo': PagingInfoFromJSON(json['paging_info']),
    };
}

export function UserSearchResponseToJSON(value?: UserSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(SearchDTOToJSON)),
        'paging_info': PagingInfoToJSON(value.pagingInfo),
    };
}

